import { z } from "zod";
////////////////////
// Jobs
////////////////////
//
// Shared inner types
//
export const JobInfoSchema = z.object({
    jobType: z.string(),
    jobId: z.string()
});
export const JobConfigSchema = z.object({
    heartbeatMissBeforeFailureMs: z.number()
});
//
// Messages
//
export const buildJobMessages = (HeartbeatUpdate)=>{
    const JobStartMessage = z.object({
        type: z.literal('start'),
        job: JobInfoSchema
    });
    const JobHeartbeatMessage = z.object({
        type: z.literal('heartbeat'),
        job: JobInfoSchema,
        update: HeartbeatUpdate
    });
    const JobWorkerDisconnectMessage = z.object({
        type: z.literal('disconnect'),
        job: JobInfoSchema
    });
    const JobEndMessage = z.object({
        type: z.literal('complete'),
        job: JobInfoSchema,
        resolution: z.union([
            z.object({
                type: z.literal('success')
            }),
            z.object({
                type: z.literal('failure'),
                error: z.string()
            })
        ])
    });
    const JobMessageTypes = z.discriminatedUnion('type', [
        JobWorkerDisconnectMessage,
        JobHeartbeatMessage,
        JobStartMessage,
        JobEndMessage
    ]);
    const JobMessages = z.object({
        type: z.literal('job'),
        message: JobMessageTypes
    });
    const WrappedJobMessages = z.object({
        type: z.literal('messages'),
        messages: z.array(JobMessages)
    });
    return WrappedJobMessages;
};
////////////////////
// Status
////////////////////
export const buildJobStatus = (HeartbeatUpdate)=>{
    const JobStatusRunning = z.object({
        type: z.literal('running'),
        heartbeat: z.object({
            lastHeartbeat: z.number(),
            msSinceHeartbeat: z.number()
        }),
        update: HeartbeatUpdate
    });
    const JobStatusCompletion = z.discriminatedUnion('type', [
        z.object({
            type: z.literal('success')
        }),
        z.object({
            type: z.literal('failure'),
            error: z.string()
        })
    ]);
    const JobStatusComplete = z.object({
        type: z.literal('complete'),
        completion: JobStatusCompletion.optional(),
        lastUpdate: HeartbeatUpdate.optional(),
        lastHeartbeat: z.object({
            lastHeartbeat: z.number(),
            msSinceHeartbeat: z.number()
        })
    });
    const JobStatusUnknown = z.object({
        type: z.literal('unknown')
    });
    const JobStatus = z.discriminatedUnion('type', [
        JobStatusRunning,
        JobStatusComplete,
        JobStatusUnknown
    ]);
    return JobStatus;
};
export const buildStatusResponse = (HeartbeatUpdate)=>{
    const JobStatus = buildJobStatus(HeartbeatUpdate);
    const JobStatusResponse = z.object({
        type: z.literal('status'),
        job: JobInfoSchema,
        jobConfig: JobConfigSchema,
        status: JobStatus
    });
    return JobStatusResponse;
};
